import React from "react";

import { Tag, TagLabel } from "@chakra-ui/react";

export interface IBoxTag {
  label?: string | JSX.Element;
  style: {
    color: string;
    backgroundColor: string;
  };
}

const AirBundleTagStatus = ({ statusBox, dataTestId }: { statusBox: IBoxTag; dataTestId?: string }) => {
  if (!statusBox) {
    return null;
  }
  return (
    <>
      {statusBox.label && (
        <Tag size="xs" {...statusBox.style}>
          <TagLabel fontWeight="extrabold" textTransform="uppercase" data-testid={dataTestId}>
            {statusBox.label}
          </TagLabel>
        </Tag>
      )}
    </>
  );
};

export default AirBundleTagStatus;
